import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
// import "./PopUp.scss";

interface IProps {
  title: string;
  children: React.ReactNode;
  id: string;
}

function PopUp(props: IProps) {
  return (
    <Wrap id={props.id}>
      <div className="shadow" />
      <div className="popLayer">
        <div>
          <button className="btnClose">
            <FontAwesomeIcon icon={faXmark} />
          </button>
          <h2>{props.title}</h2>
        </div>
        <div className="content">
          <div>{props.children}</div>
        </div>
      </div>
    </Wrap>
  );
}

export default PopUp;

const Wrap = styled.div`
  z-index: 9997 !important;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  text-align: center;

  &::before {
    content: "";
    display: inline-block;
    height: 100%;
    vertical-align: middle;
  }

  .shadow {
    opacity: 1;
    z-index: -1;
    width: 100%;
    height: 100%;
    position: fixed;
    padding-bottom: 0px;
    top: 0;
    left: 0;
    background-size: cover;
    background: rgba(0, 0, 0, 0.7);
  }

  .popLayer {
    position: relative;
    box-sizing: border-box;
    display: inline-block;
    vertical-align: middle;
    width: 580px;
    height: auto;
    border-top: none;
    box-shadow: none;
    border-radius: 0.625rem;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);

    background: var(--gray-800);
    padding: 3.75rem;
    font-size: 0.875rem;
    color: var(--gray-300);
    text-align: start;
    width: auto;
    height: 95%;
    overflow: hidden;
  }

  h2 {
    color: var(--gray-200);
    font-size: 1.25rem;
    padding-bottom: 1.25rem;
    border-bottom: 1px solid var(--gray-600);
  }

  .btnClose {
    position: absolute;
    right: 1.5rem;
    top: 1.5rem;
    background: transparent;
    color: var(--gray-100);
    font-size: 1.25rem;
  }

  .content {
    box-sizing: border-box;
    overflow-y: auto;
    max-height: 80vh;
    padding: 0.5rem 1.25rem;
    // margin-bottom: 0.25rem;
    background: var(--gray-800);
    color: var(--gray-100);

    scrollbar-color: rgba(0, 171, 194, 0.35) rgba(0, 171, 194, 0.55) !important; //moz
    scrollbar-width: 4px !important; //moz
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      background: rgba(0, 171, 194, 0.35);
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background: rgba(0, 171, 194, 0.55);
    }
    &::-webkit-scrollbar-thumb:hover {
      background: rgba(0, 171, 194, 0.95);
    }
  }
`;
